import React, { useState,useEffect,useContext  } from "react";
import { Link,useParams } from 'react-router-dom';
import Lang from '../lang/translations';
import Context from '../context/context';
import ReactGA from 'react-ga4';
import helpers from "../_helpers/helpersFunction";
import { useNavigate  } from "react-router-dom";
import AngelGallery from './angel_gallery'; 

export default function UserProfile(props) {
	
	

	
	const country = helpers.getCountry()
	const {collection_folder, default_folder} = helpers.getCDNfolder()
	const [mainImage, setMainImage] = useState("");

	
	let params = useParams();
	const profiloAttuale = params.u;
	const  context = useContext(Context)
	let navigate = useNavigate();
	
	const [datiProfilo, SetDatiProfilo] = useState({});

	
	var trackerId = localStorage.getItem('trackerId');


	function bloccaUtente(){

		const blocco = Lang( {"w": "utente_bloccato","page": "user"} );
		context.setTooltip({ visible: true, title: blocco,text:"",variant:"success",autoClose:true,tipo:"like"})

	}

	function sendAlike(){

		if(props.verifiedUser){
			const scalo_crediti = (context.flusso.creditiLike && typeof context.flusso.creditiLike === "number") ? true : false
			context.Socket.emit('like', {'trackerId': trackerId, 'angelId':datiProfilo.id,"servizio": window.location.hostname,"country":country, "screenName":datiProfilo.screenName, "scalo_crediti": scalo_crediti});
			var profiliLike = context.profiliLike
			profiliLike.push(datiProfilo.id)
			context.setProfiliLike(profiliLike)
		}
	}

	const chatDaProfilo = () =>{
		//helpers.postVisitedProfile(profiloAttuale)
		//ReactGA.event({category: 'User',action: 'Bottone chat da profilo',label:profiloAttuale})
	}
	
	useEffect(() => {
		
		fetch(process.env.REACT_APP_DISPENSER+"/"+profiloAttuale+"/"+country+"/"+context.user_info.cerco)
		  .then(response => response.json())
		  .then(data => {
			  SetDatiProfilo(data[0])


			  var main_image = null;

			  if (data[0].gender === "male") {
				  main_image = "https://yp.cloudfileimages.com/uploads/photo/" + data[0].default_photo
			  } else {
				  main_image = process.env.REACT_APP_CDN + "/" + default_folder + "/" + data[0].id + ".jpg"
			  }

			  setMainImage(main_image)
			 // ReactGA.pageview('/user/'+profiloAttuale, "Profilo angel");
			});

		  
	},[profiloAttuale,country]);
	
	


	useEffect(() => {
		//ReactGA.pageview('/find/'+page, "Find");
		helpers.eventPost(trackerId,params.u,"vista_profilo")
		
		context.Socket.on('like', (messaggio) => {
			if (messaggio.creditiLike <= 0 && (context.flusso.creditiLike && typeof context.flusso.creditiLike === "number") && context.premiumLevel === 0){
				helpers.showHook("file_like",messaggio.data,context,navigate)
				//ReactGA.modalview('/hook/fine_like/'+props.id)
				return
			}else{
				const inviato = Lang( {"w": "mi_piace_inviato","page": "user"} );
				context.setTooltip({visible:true,title:inviato,text:"",variant:"success",autoClose:true,tipo:"like"})
				return
			}

		})
	},[])
	
	const handleThumbnailSelect = (src) => {

        setMainImage(src); // Aggiorna l'immagine principale
    };
	

	function Avatar_svg(){
		return (<svg fill="#000000" width="20px" style={{marginRight:"10px"}} viewBox="0 0 36 36" version="1.1"  >
			<title>avatar-solid</title>
			<path d="M30.61,24.52a17.16,17.16,0,0,0-25.22,0,1.51,1.51,0,0,0-.39,1v6A1.5,1.5,0,0,0,6.5,33h23A1.5,1.5,0,0,0,31,31.5v-6A1.51,1.51,0,0,0,30.61,24.52Z" class="clr-i-solid clr-i-solid-path-1"></path><circle cx="18" cy="10" r="7" class="clr-i-solid clr-i-solid-path-2"></circle>
			<rect x="0" y="0" width="36" height="36" fill-opacity="0"/>
		</svg>)
	}


	function scritta_sesso(el){
		if(el === "male"){
			return Lang( {"w": "uomo","page": "user"} )
		}else{
			return Lang( {"w": "donna","page": "user"} )
		}
	}
		  
    return ( <div> { datiProfilo && (<div className="all-container bg-light profilepage padding_bottom">
	<div className="container filters-no-padding" role="main">
	<div className="fos_user_user_show p-md-3">
		<div className="row no-gutters">
			<div className="rounded col-sm-6 col-12">
				<img alt="" className="card-img-top rounded" src={mainImage}/>
			</div>
			
			<div className="col-sm-6 col-12">
				
				<div className="buttons_profile">
					<Link className="btn to_chat" onClick={()=> chatDaProfilo()} to={"/chats/"+profiloAttuale}><i className="fa fa-comment"></i> <Lang w={"chat"} page={"user"}/></Link>
					<Link style={context.profiliLike.includes(profiloAttuale) ? {color:"#910101"} : {color:"var(--relevantColor)"}} to={()=> {return true}} onClick={()=> sendAlike()} data-status="no_liked" data-userid="128072" className="btn to_like"><i className="fa fa-heart" ></i> <Lang w={"mi_piace"} page={"user"}/></Link>
				</div>
			
			
			
				<ul className="list-group list-group-flush px-md-3">
					<li className="list-group-item pt-md-1 border-0 pb-0">
						<div className="justify-content-between">
							<h3 className="text-capitalize m-0">{datiProfilo.screenName}<span className="change_favorites" data-id="128072" data-action="add"></span></h3>
							<h4>{context.fluxId==="0000" ? null : <span>{datiProfilo.about}</span>}</h4>
						</div>
					</li>
				 	<hr/>
							<li className="list-group-item"><strong><Avatar_svg />{datiProfilo.age} <Lang w={"anni"} page={"user"} />, {scritta_sesso(datiProfilo.gender)} - <Lang w={"vicino_a_te"} page={"user"}/></strong> </li>
					<hr/>
					<li className="list-group-item"> {datiProfilo.hair_color && (<><strong><Lang w={"capelli"} page={"user"}/>:</strong> <Lang w={datiProfilo.hair_color} page={"user"}/></>)} </li>
					<hr/>
					<li className="list-group-item"><strong> <Lang w={"altezza"} page={"user"}/>:</strong>  {datiProfilo.height ? datiProfilo.height : "--"}</li>
					<hr/>
					<li className="list-group-item"><strong> <Lang w={"descrizione"} page={"user"}/>:</strong> <span> {datiProfilo.description} </span></li>
					<hr/>
					
					
					 
					
				</ul>
				
		
					<div className="jumbotron">
						<Link className="btn to_chat fullwidth" onClick={()=> chatDaProfilo()} to={"/chats/"+profiloAttuale}><i className="fa fa-comment"></i> <Lang w={"scrivile_in_privato"} page={"user"}/></Link>

					</div>
					
					{window.location.hostname === "jammydate.com" && (
							<div className="text-center">
								<span style={{ cursor: "pointer" }} onClick={() => bloccaUtente()}>
									<Lang w={"segnala_blocca"} page={"user"} />
								</span>
							</div>
					)}
						
			</div>
		</div>
	</div>
	

	
</div>
</div>)} </div> );


}

